import Typewriter from "typewriter-effect";
import { EmptyState } from "../EmptyStateComponent";

export function EmptyComponentWithAnimation({
  icon,
  title,
  description,
  phrases,
}) {
  return (
    <div className="h-full flex items-center justify-center">
      <EmptyState
        icon={icon}
        title={title}
        description={description}
        action={
          <div className="text-xl text-gray-600 font-medium min-h-[32px]">
            <Typewriter
              onInit={(typewriter) => {
                typewriter.pauseFor(2500).deleteAll().start();
              }}
              options={{ autoStart: true, loop: true, strings: phrases }}
            />
          </div>
        }
      />
    </div>
  );
}
